import Vue from 'vue';

export const btnRendererZoomAcceptRequest = {
    template: `<span><button   class="btn-sm btn-secondary">Req Zoom Accept</button></span>`
}

export const btnRendererExtendClass = {
    template: `<span v-if="params.data.assignCount <= params.data.countAttended">
        <button color="primary"  class="btn-sm btn-info ">Extend Class</button>
      </span>`
}



export const btnRendererSave = {
    template: `<span><button color="primary"  class="btn-sm btn-primary ">Save</button></span>`
}
export const btnRendererComplete = {
    template: `<span><button color="primary"  class="btn-sm btn-primary ">Complete</button></span>`
}
export const btnRendererAttend = {
    template: `<span v-if="params.data.attendStatus==='NOCLASS'"><button class="btn-sm green">Attend</button></span>`
}
export const btnRendererNoClass = {
    template: `<span><button class="btn-sm grey">No Class</button></span>`
}
export const btnRendererNoShow = {
    template: `<span v-if="params.data.attendStatus==='NOCLASS'"><button class="btn-sm btn-danger ">No Show</button></span>`
}
export const btnRendererPostpone = {
    template: `<span >
                    <button v-if="params.data.attendStatus==='NOCLASS'" 
                        class="btn-sm btn-primary" >{{ $t('postpone') }}
                    </button>
              </span>` 
}
export const btnRendererTeacherError = {
    template: `<span><button class="btn-sm btn-primary" >Teacher Issue</button></span>`
}
